import React from 'react'
import { Member } from '../../types/Tribe'
import { useNavigate } from 'react-router-dom'

interface LeadershipFieldProps {
  label: string
  leaders: Array<Member>
  readOnly?: boolean
  size?: 'sm' | 'md'
}

const LeadershipField = ({
  label,
  leaders,
  readOnly = false,
  size = 'md',
}: LeadershipFieldProps) => {
  const navigate = useNavigate()
  const leader = leaders[0]
  const name =
    leader && leader.id !== -1
      ? `${leader.firstName} ${leader.lastName}`.trim()
      : '---'
  const isPlaceholder = name === '---'

  const handleClick = () => {
    if (readOnly || !leader || leader.id === -1) return
    navigate(`/members/${leader.id}`)
  }

  return (
    <div>
      <div className="tribe-org__leadership-label">{label}</div>
      <div
        className={`tribe-org__leadership-value${isPlaceholder ? ' tribe-org__leadership-value--muted' : ''}${size === 'sm' ? ' tribe-org__leadership-value--sm' : ''}${!readOnly && !isPlaceholder ? ' tribe-org__leadership-value--clickable' : ''}`}
        onClick={handleClick}
      >
        {name}
      </div>
    </div>
  )
}

interface Props {
  adm: Array<Member>
  ba: Array<Member>
  sm: Array<Member>
  admLabel: string
  baLabel: string
  smLabel: string
  readOnly?: boolean
  variant?: 'column' | 'shared'
}

const TribeLeadershipContainer = ({
  adm,
  ba,
  sm,
  admLabel,
  baLabel,
  smLabel,
  readOnly = false,
  variant = 'column',
}: Props) => {
  if (variant === 'shared') {
    return (
      <div className="tribe-org__shared-leadership">
        <div className="tribe-org__shared-leadership-item">
          <LeadershipField
            label={admLabel}
            leaders={adm}
            readOnly={readOnly}
          />
        </div>
        <div className="tribe-org__shared-leadership-divider" />
        <div className="tribe-org__shared-leadership-item">
          <LeadershipField label={baLabel} leaders={ba} readOnly={readOnly} />
        </div>
        <div className="tribe-org__shared-leadership-divider" />
        <div className="tribe-org__shared-leadership-item">
          <LeadershipField label={smLabel} leaders={sm} readOnly={readOnly} />
        </div>
      </div>
    )
  }

  return (
    <div className="tribe-org__leadership-card">
      <div className="tribe-org__leadership-card-adm">
        <LeadershipField label={admLabel} leaders={adm} readOnly={readOnly} />
      </div>
      <div className="tribe-org__leadership-card-row">
        <LeadershipField
          label={baLabel}
          leaders={ba}
          readOnly={readOnly}
          size="sm"
        />
        <LeadershipField
          label={smLabel}
          leaders={sm}
          readOnly={readOnly}
          size="sm"
        />
      </div>
    </div>
  )
}

export default TribeLeadershipContainer
